import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { LovComponent } from './lov.component';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  declarations: [LovComponent],
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    ProgressBarModule,
    MultiSelectModule
  ],
  exports:[LovComponent]
})
export class LovModule { }
